
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as cartf2Su9dekOxiUkd_CJg20ywMexbzPK8lfCbtGx_3SVdEMeta } from "/app/app/pages/cart.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta } from "/app/app/pages/login.vue?macro=true";
import { default as searchkbb43gtkc60rGLWak_E_6zSn2BTK1bKkOmKyUR_kXcMMeta } from "/app/app/pages/search.vue?macro=true";
import { default as checkoutFLMN_AaNxnM_h9ALAUimIAaWpDkJA4XoG0OMrXZi_WgMeta } from "/app/app/pages/checkout.vue?macro=true";
import { default as _91_46_46_46slug_93eDHq9Sb_fpMilQ4SKVcOZkf94gCZN8K0Lr0WXAEt9UMMeta } from "/app/app/pages/[...slug].vue?macro=true";
import { default as registrationWo0aMi393XRx7ZmUFW3fpyiY5yHv5duOXUbkzY05Z7wMeta } from "/app/app/pages/registration.vue?macro=true";
import { default as indexLdNUQ4MIhBpg7fAzfpvdMU7gu9Bg6nib_8MieNFMpMUMeta } from "/app/app/pages/profile/index.vue?macro=true";
import { default as store_45locatorsuqGSlMaKZgSwc0plHN9BB1yjtdqUhjQnyuFIowyWooMeta } from "/app/app/pages/store-locator.vue?macro=true";
import { default as forgot_45password_svvr_HXOSYgUMkqXVPpKJfwi_QEp8hjfRcKoAib3NwMeta } from "/app/app/pages/forgot-password.vue?macro=true";
import { default as confirmationxip9lZOMv_hFs1uHeSlbKhP49afyhNaCBD20Suy71JMMeta } from "/app/app/pages/order/confirmation.vue?macro=true";
import { default as my_45wishlist_kc3DA9cBbCcztUOu_jT0FZFD7NJm82NanWINQyK1Y0Meta } from "/app/app/pages/profile/my-wishlist.vue?macro=true";
import { default as _91id_93VvJfEwDZS77RAe9G1CxM05fYd9QpUETGW4vkGOPL_PsMeta } from "/app/app/pages/profile/my-orders/[id].vue?macro=true";
import { default as indexKQhzAvXajMWZUaPUr40WyNCuot8AbHsU9t9Lrh1ko6oMeta } from "/app/app/pages/profile/my-orders/index.vue?macro=true";
export default [
  {
    name: "cart___en-US",
    path: "/cart",
    meta: cartf2Su9dekOxiUkd_CJg20ywMexbzPK8lfCbtGx_3SVdEMeta || {},
    component: () => import("/app/app/pages/cart.vue")
  },
  {
    name: "cart___fr-FR",
    path: "/fr-FR/panier",
    meta: cartf2Su9dekOxiUkd_CJg20ywMexbzPK8lfCbtGx_3SVdEMeta || {},
    component: () => import("/app/app/pages/cart.vue")
  },
  {
    name: "index___en-US",
    path: "/",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___fr-FR",
    path: "/fr-FR",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "login___en-US",
    path: "/login",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "login___fr-FR",
    path: "/fr-FR/connexion",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "search___en-US",
    path: "/search",
    component: () => import("/app/app/pages/search.vue")
  },
  {
    name: "search___fr-FR",
    path: "/fr-FR/recherche",
    component: () => import("/app/app/pages/search.vue")
  },
  {
    name: "checkout___en-US",
    path: "/checkout",
    meta: checkoutFLMN_AaNxnM_h9ALAUimIAaWpDkJA4XoG0OMrXZi_WgMeta || {},
    component: () => import("/app/app/pages/checkout.vue")
  },
  {
    name: "checkout___fr-FR",
    path: "/fr-FR/paiement",
    meta: checkoutFLMN_AaNxnM_h9ALAUimIAaWpDkJA4XoG0OMrXZi_WgMeta || {},
    component: () => import("/app/app/pages/checkout.vue")
  },
  {
    name: "slug___en-US",
    path: "/:slug(.*)*",
    component: () => import("/app/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr-FR",
    path: "/fr-FR/:slug(.*)*",
    component: () => import("/app/app/pages/[...slug].vue")
  },
  {
    name: "registration___en-US",
    path: "/registration",
    meta: registrationWo0aMi393XRx7ZmUFW3fpyiY5yHv5duOXUbkzY05Z7wMeta || {},
    component: () => import("/app/app/pages/registration.vue")
  },
  {
    name: "registration___fr-FR",
    path: "/fr-FR/inscription",
    meta: registrationWo0aMi393XRx7ZmUFW3fpyiY5yHv5duOXUbkzY05Z7wMeta || {},
    component: () => import("/app/app/pages/registration.vue")
  },
  {
    name: "profile___en-US",
    path: "/profile",
    meta: indexLdNUQ4MIhBpg7fAzfpvdMU7gu9Bg6nib_8MieNFMpMUMeta || {},
    component: () => import("/app/app/pages/profile/index.vue")
  },
  {
    name: "profile___fr-FR",
    path: "/fr-FR/profil",
    meta: indexLdNUQ4MIhBpg7fAzfpvdMU7gu9Bg6nib_8MieNFMpMUMeta || {},
    component: () => import("/app/app/pages/profile/index.vue")
  },
  {
    name: "store-locator___en-US",
    path: "/store-locator",
    meta: store_45locatorsuqGSlMaKZgSwc0plHN9BB1yjtdqUhjQnyuFIowyWooMeta || {},
    component: () => import("/app/app/pages/store-locator.vue")
  },
  {
    name: "store-locator___fr-FR",
    path: "/fr-FR/recherche-magasin",
    meta: store_45locatorsuqGSlMaKZgSwc0plHN9BB1yjtdqUhjQnyuFIowyWooMeta || {},
    component: () => import("/app/app/pages/store-locator.vue")
  },
  {
    name: "forgot-password___en-US",
    path: "/forgot-password",
    component: () => import("/app/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___fr-FR",
    path: "/fr-FR/mot-de-passe-oublie",
    component: () => import("/app/app/pages/forgot-password.vue")
  },
  {
    name: "order-confirmation___en-US",
    path: "/order/confirmation",
    meta: confirmationxip9lZOMv_hFs1uHeSlbKhP49afyhNaCBD20Suy71JMMeta || {},
    component: () => import("/app/app/pages/order/confirmation.vue")
  },
  {
    name: "order-confirmation___fr-FR",
    path: "/fr-FR/commande/confirmation",
    meta: confirmationxip9lZOMv_hFs1uHeSlbKhP49afyhNaCBD20Suy71JMMeta || {},
    component: () => import("/app/app/pages/order/confirmation.vue")
  },
  {
    name: "profile-my-wishlist___en-US",
    path: "/profile/my-wishlist",
    meta: my_45wishlist_kc3DA9cBbCcztUOu_jT0FZFD7NJm82NanWINQyK1Y0Meta || {},
    component: () => import("/app/app/pages/profile/my-wishlist.vue")
  },
  {
    name: "profile-my-wishlist___fr-FR",
    path: "/fr-FR/profil/ma-liste-d-envies",
    meta: my_45wishlist_kc3DA9cBbCcztUOu_jT0FZFD7NJm82NanWINQyK1Y0Meta || {},
    component: () => import("/app/app/pages/profile/my-wishlist.vue")
  },
  {
    name: "profile-my-orders-id___en-US",
    path: "/profile/my-orders/:id()",
    meta: _91id_93VvJfEwDZS77RAe9G1CxM05fYd9QpUETGW4vkGOPL_PsMeta || {},
    component: () => import("/app/app/pages/profile/my-orders/[id].vue")
  },
  {
    name: "profile-my-orders-id___fr-FR",
    path: "/fr-FR/profil/mes-commandes/:id()",
    meta: _91id_93VvJfEwDZS77RAe9G1CxM05fYd9QpUETGW4vkGOPL_PsMeta || {},
    component: () => import("/app/app/pages/profile/my-orders/[id].vue")
  },
  {
    name: "profile-my-orders___en-US",
    path: "/profile/my-orders",
    meta: indexKQhzAvXajMWZUaPUr40WyNCuot8AbHsU9t9Lrh1ko6oMeta || {},
    component: () => import("/app/app/pages/profile/my-orders/index.vue")
  },
  {
    name: "profile-my-orders___fr-FR",
    path: "/fr-FR/profil/mes-commandes",
    meta: indexKQhzAvXajMWZUaPUr40WyNCuot8AbHsU9t9Lrh1ko6oMeta || {},
    component: () => import("/app/app/pages/profile/my-orders/index.vue")
  }
]